module.exports = __webpack_public_path__ + "img/desk1.e0f353ad.png";